import { Params } from 'react-router-dom';

/**
 * Turns one matched URL path into a key: splits it on `/`, drops the empty
 * pieces and any piece that is a route param's value (the vehicle id), then
 * lowercases what is left.
 *
 * @example
 * toPageKey('/applicant/3f2c…/submit-application', { vehicleId: '3f2c…' });
 * // → 'applicant/submit-application'
 *
 * toPageKey('/sign-up/', {}); // → 'sign-up'
 * toPageKey('/', {}); //         → '' (no key)
 */
export const toPageKey = (pathname: string, params: Params): string => {
  const paramValues = Object.values(params);

  return pathname
    .split('/')
    .filter(
      (segment): boolean => Boolean(segment) && !paramValues.includes(segment),
    )
    .join('/')
    .toLowerCase();
};
